import { createSlice } from '@reduxjs/toolkit';
import { getBidsRoutine } from './bid.routines';

export const NotificationLevel = {
    DEBUG: 'debug',
    INFO: 'info',
    SUCCESS: 'success',
    WARN: 'warn'
};

const initialState = { bids: [], isBusy: false };

const bidSlice = createSlice({
    name: 'bid',
    initialState,
    reducers: {
        addBid(state) {
            state.isBusy = true;
        },
        addBidSuccess(state) {
            state.isBusy = false;
        },
        addBidError(state) {
            state.isBusy = false;
        }
    },
    extraReducers: {
        [getBidsRoutine.SUCCESS]: (state, { payload: { bids } }) => {
            state.isBusy = false;
            state.bids = bids;
        }
    }
});

export const { addBid, addBidSuccess, addBidError } = bidSlice.actions;

export default bidSlice.reducer;
